/**
 * Removes the 'us' segment from the URL path if it exists.
 * @param urlPath - The URL path to manipulate.
 * @returns The updated URL path.
 */
export const removeUSFromPath = (urlPath: string): string => {
  const segments = urlPath.split('/');
  if (segments[2] === 'us') {
    segments.splice(2, 1);
  }
  return segments.join('/');
};
